import React from 'react'
import Card from  './Card'
import SecTitle from './SecTitle'

class BankInvoiceFunc extends React.Component {

    render() {
        return (
                <div className="container box">
                    <SecTitle  type="func" title="header" />

                    <div className="auto-col-2">
                        <Card title="send" type="func" />
                        <Card title="clock" type="func" />
                    </div>
                    <div className="auto-col-2">
                        <Card title="download" type="func" />
                        <Card title="upload" type="func" />
                    </div>
                    <div className="auto-col-2">
                        <Card title="msg" type="func" />
                        <Card title="memo" type="func" />
                    </div>
                    <div className="auto-col-2">
                        <Card title="history" type="func" />
                        <Card title="files" type="func" />
                    </div>
                    <div className="auto-col-2">
                        <Card title="filter3" type="func" />
                        <Card title="nolimit" type="func" />
                    </div>
                    <div className="auto-col-2">
                        <Card title="beforesendmsg" type="func" />
                        <Card title="option" type="func" />
                    </div>
                </div>
        )
    }
}

export default BankInvoiceFunc

